import { createSelector } from 'reselect';
import { getMenu } from './MenuSelectors';
import { calcCartItemPrice } from '../helpers/menu-helpers';

const getItems = state => state.order.cart.items;
const getCustomer = state => state.customer;
const getDeliveryInfo = state => state.order.deliveryInfo;
const getTableNumber = state => state.order.tableNumber;
const getTipPercentage = state => state.order.requestedTipPercentage;
const getBranchId = state => state.business.branch.id;

export const getCart = state => state.order.cart;

export const getTipOptions = createSelector(
    [getTipPercentage],
    (percentage) => {
        if (percentage) {
            return { percentage };
        }
        return null;
    }
);

export const getCartItems = createSelector(
    [getMenu, getItems],
    (menu, cartItems) => {
        const prepItem = cartItem => {
            const price = calcCartItemPrice(menu.catalog, cartItem);
            const selections = Object.keys(cartItem.selections).reduce((final, key) => {
                return final.concat(...cartItem.selections[key].map(subItem => prepItem(subItem)));
            }, []);

            return { ...menu.catalog.items[cartItem.id], selections, price, cartItem };
        };

        return cartItems.map(prepItem);
    }
);

export const prepareCheckoutData = createSelector(
    [getCart, getCustomer, getTableNumber, getTipOptions, getDeliveryInfo, getBranchId],
    (cart, customer, tableNumber, tipOptions, delivery, branchId) => {
        const { tableLocation: rawTableLocation, ...customerFields } = customer;
        const tableLocation = (rawTableLocation || '').trim();
        const customerName = tableLocation
            ? `${customer.name} (${tableLocation})`
            : customer.name;

        return {
            customer: { ...customerFields, name: customerName },
            delivery,
            tipOptions,
            tableNumber,
            cart,
            branchId
        };
    }
);
